export const LeadQuality = {
	NEW: 'new',
	GOOD: 'good',
	BAD: 'bad',
};
